<template>
    <submit-button :form="form" class="btn-nlcaa btn-sm ml-auto" icon="fa-envelope" @click="save()">Notify me when the course is available</submit-button>
</template>
<script>
    export default {

        props:{
            course: {
                type: Object,
                required: true,
            }
        },

        data(){
            return {
                form: new Form({ email: ''})
            }
        },

        methods: {
            save() {
                this.form.post(`/courses/${this.course.slug}/notify-me`).then(response => {
                    Alert.success('You will receive a email when the class is available!');
                })
            }
        }
    }
</script>